<template>
  <div class="breadcrumb-header" v-if="breadcrumbVisible" >
    <ul>
      <li>
        <router-link  :to="{name: 'mainPage'}">
          Strona główna
        </router-link>
      </li>
      <li v-for="link in breadcrumbPath">
        <router-link v-if="link.route"  :to="link.route">{{ link.title}}</router-link>
        <span v-else>{{ link.title}}</span>
      </li>
    </ul>
  </div>
</template>

<script>

  import { mapState } from 'vuex';

  export default {
    computed: {
      ...mapState({
          breadcrumbPath: state => state.breadcrumbPath,
          breadcrumbVisible: state => state.breadcrumbVisible,
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/template/Breadcrumb.vue